import { useQuery, UseQueryOptions } from 'react-query';
import { AdGroupsAndDataScopesGroupsDto, RoleDto } from '../../../codegen/Swagger';
import { getApi } from '../../../config/SwaggerApi';
import { configQueryReactSimpleRequestSecurity } from '../config';
const fetchGroupsByRoleId = (role: RoleDto) =>
    getApi()
        .security.securityGetAdGroupsByRoleIdGet({ RoleId: role.id })
        .then((response) => response.data);

const useGroupsByRoleId = (role: any, options?: UseQueryOptions) => {
    const groupsQuery = useQuery<AdGroupsAndDataScopesGroupsDto, Error>(
        ['groups-roles-', role?.id],
        () => fetchGroupsByRoleId(role),
        {
            ...configQueryReactSimpleRequestSecurity,
            enabled: role != null,
        },
    );

    return groupsQuery;
};

export default useGroupsByRoleId;
